import { ShopEvents } from '~/analytics/shop/shopEvents.types'

import AnalyticsEvents_V2 from '../analyticsGA4'
import { Labels, PortalProducts } from '../types/analytics.type'

class ShopAnalytics extends AnalyticsEvents_V2 {
  public constructor() {
    super(PortalProducts.SHOP)
  }

  public logBuyItem(sku: string, price: number, isSuccess: boolean): void {
    this.logEvent({
      event: ShopEvents.BUY_ITEM,
      title: sku,
      gems: price,
      status: isSuccess ? Labels.SUCCESSFUL : Labels.UNSUCCESSFUL,
    })
  }

  public logUpgradeItem(sku: string, price: number, isSuccess: boolean): void {
    this.logEvent({
      event: ShopEvents.UPGRADE_ITEM,
      title: sku,
      gems: price,
      status: isSuccess ? Labels.SUCCESSFUL : Labels.UNSUCCESSFUL,
    })
  }
}

export default new ShopAnalytics()
